import * as React from 'react';
import styled from '@emotion/styled';

const OrderedList = styled.ol`
  margin: 0;
`;

const UnorderedList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

interface ListProps {
  variant?: string;
  children?: React.ReactNode;
  className?: string;
}

export const List = ({ variant = 'unordered', className, children }: ListProps): JSX.Element => {
  if (variant === 'ordered') return <OrderedList className={className}>{children}</OrderedList>;
  return <UnorderedList className={className}>{children}</UnorderedList>;
};
